import React, { useState, useEffect } from "react";
import Clockimage from "../Clockimage.png";
import "./Style/Clock.css";

export default function Clock() {
  const [sec, setSec] = useState(0);
  const [min, setMin] = useState(0);
  const [hr, setHr] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      let d = new Date();
      let htime = d.getHours();
      let mtime = d.getMinutes();
      let stime = d.getSeconds();
      // console.log(htime);
      let hrotation = 30 * htime + mtime / 2;
      let mrotation = 6 * mtime;
      let srotation = 6 * stime;
      setSec(srotation);
      setMin(mrotation);
      setHr(hrotation);
    }, 1000);
  }, [sec, min, hr]);

  return (
    <div className="clock-img">
      <div className="hands">
        <div className="sec" style={{ transform: `rotate(${sec}deg)` }}></div>
        <div className="min" style={{ transform: `rotate(${min}deg)` }}></div>
        <div className="hr" style={{ transform: `rotate(${hr}deg)` }}></div>
      </div>
      <img src={Clockimage} alt="" />
    </div>
  );
}
